module.exports = __webpack_public_path__ + "static/2-5bf4a180e5b1c46baf4a557c4296c668.jpg";